<template>
  <div class="row">
    <div class="col-md-6">
      <label class="text text-bold text-primary">{{list1Label}}</label>
      <select-component v-model="list1Value" @change="(val) => (list1Value = val)" :name="list1Name">
        <option value>Todos</option>
        <option
          v-for="item of list1"
          :key="item[list1Key]"
          :value="item[list1Key]"
        >{{ item[list1FieldLabel] }}</option>
      </select-component>
    </div>
    <div class="col-md-6">
      <label class="text text-bold text-primary">{{list2Label}}</label>
      <select-component value ref="select2" :name="list2Name">
        <option value>{{ !list1Value ? `Selecione primeiro o(a) ${list1Label}` : `Todos do(a) ${list1Label}` }}</option>
        <option
          v-for="item of list2Elements"
          :key="item[list2Key]"
          :value="item[list2Key]"
        >{{ item[list2FieldLabel] }}</option>
      </select-component>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list1: {
      required: true
    },
    list2: {
      required: true
    },
    list1Key: {
      required: true
    },
    list1FieldLabel: {
      required: true
    },
    list1Name: {
      required: true
    },
    list1Label: {
      required: true
    },
    list2Key: {
      required: true
    },
    list2Name: {
      required: true
    },
    list2Label: {
      required: true
    },
    list2FieldLabel: {
      required: true
    },
    list2Reference: {
      required: true
    }
  },
  data: () => ({
    list1Value: ""
  }),
  computed: {
    list2Elements() {
      if (!this.list1Value) {
        return [];
      }

      return this.list2.filter(item => {
        return item[this.list2Reference] == this.list1Value;
      });
    }
  },
  watch: {
    list2Elements: function() {
      setTimeout(() => {
        this.$refs.select2.generateOptions()
      }, 500)
    }
  }
};
</script>
